import { configureStore, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'
import { enableBatching } from 'redux-batched-actions'

import appConfig from '@/libs/config/app'
import { instagramApi } from '@/services/instagram'
import { localApi } from '@/services/local'
import { omsApi } from '@/services/oms'

import apiErrorMiddleware from './apiErrorMiddleware'
import rootReducer from './rootReducer'

export const makeStore = (preloadedState?: RootState) =>
  configureStore({
    reducer: enableBatching(rootReducer),
    middleware: (getDefaultMiddleware) => {
      const middleware = getDefaultMiddleware({
        immutableCheck: !appConfig.isTest,
        serializableCheck: !appConfig.isTest,
      }).concat(omsApi.middleware, localApi.middleware, instagramApi.middleware)

      if (!appConfig.isTest) return middleware.concat(apiErrorMiddleware)

      return middleware
    },
    devTools: true,
    preloadedState,
  })

export const store = makeStore()

export type AppStore = ReturnType<typeof makeStore>
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = AppStore['dispatch'] &
  ThunkDispatch<RootState, void, UnknownAction>
